import toMoment from "./toMoment";

export default function toIsoDate(value, timezone) {
	return toMoment(timezone, value)?.format('YYYY-MM-DD');
}